"use client";
import { useState } from "react";
import LocalAPIManager from "../../utils/LocalAPIManager";
import { useRouter } from "next/navigation";

import { useForm } from "react-hook-form";
import { toastError, toastInfo } from "@/utils/ToastsManager";
import EmailInvalidIndicator from "@/components/ui/Login/EmailInvalidIndicator";

import dynamic from "next/dynamic";
import { emailRegex } from "@mltask/core/Utils/RegexHelper";
const SimpleTextInput = dynamic(
  () => import("@/components/ui/Input/SimpleTextInput"),
  {
    ssr: false,
  }
);
type Props = {};

export default function ResetPasswordUI({}: Props) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const router = useRouter();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  async function recoverPassword() {
    setLoading(true);
    try {
      await LocalAPIManager.resetPassword(email);
      toastInfo("Check your inbox, recovery email sent");
      router.push(`/resetpassword/confirm?email=${email}`);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  }
  const loadingStyle = "loading-md loading loading-dots text-secondary";
  return (
    <section className="mx-auto my-auto max-w-xl ">
      <form
        noValidate
        onSubmit={handleSubmit((data) => {
          recoverPassword();
        })}
      >
        <div className="flex items-center justify-center py-5 ">
          <div className="rounded-md bg-base-100 p-8 text-base-content shadow-md shadow-neutral">
            <div className="mb-8">
              <h1 className="mx-auto mb-1 text-xl font-bold leading-tight tracking-tight transition-all  sm:text-4xl">
                Forgot your password?
              </h1>
              <p className="mt-2  ">
                {`Don't fret! Just type in your email and we will send you a code to reset your password!`}
              </p>
            </div>

            <div className="mt-4 space-y-4 md:space-y-5 lg:mt-5">
              <div className="space-y-5">
                <SimpleTextInput
                  registrar={register("email", {
                    required: true,
                    pattern: emailRegex,
                    onChange: (e) => {
                      setEmail(e.target.value);
                    },
                  })}
                  errorSection={
                    errors["email"] && <EmailInvalidIndicator email={email} />
                  }
                  inputType="email"
                  title="Your Email"
                  placeholder="Ex. john@smith.com"
                  value={email}
                  pathD="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                />

                <div>
                  <button
                    type="submit"
                    className={`btn ${
                      loading ? "btn-disabled" : ""
                    } inline-flex w-full items-center justify-center rounded-md border border-transparent bg-gradient-to-r from-primary to-[color-mix(in_oklab,oklch(var(--p)),black_7%)] text-base font-semibold normal-case text-primary-content transition-all duration-200 hover:opacity-90 focus:opacity-90 focus:outline-none`}
                  >
                    {loading && <span className={`${loadingStyle}`}></span>}
                    Send Recovery Email
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
}
